module.exports = __webpack_public_path__ + "static/media/caddie_icon_w.ddcc31b8.png";